import { render } from "./down-filled.svg?vue&type=template&id=02ce419c"
const script = {}

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__